/**
 * Debounce is a utility function that will delay the execution of a function,
 * and disregard any other calls to the function until the delay has passed.
 *
 * @param func - function to be debounced
 * @param delay - time in ms to wait before calling the function and disregard any other calls
 * @returns
 */
export function debounce<T extends (...args: any[]) => any>(func: T, delay: number): () => void {
    let timeoutId: ReturnType<typeof setTimeout>;

    return (...args: Parameters<T>) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}
